type MarketEventProps = Record<string, string | number | boolean | null | undefined>

declare global {
  interface Window {
    ym?: (counterId: number, method: string, goal: string, params?: MarketEventProps) => void
  }
}

const YM_COUNTER_ID = Number((import.meta as { env?: { VITE_YM_COUNTER_ID?: string } }).env?.VITE_YM_COUNTER_ID ?? 0)

export const trackMarketEvent = (name: string, props: MarketEventProps = {}) => {
  if (typeof window !== 'undefined' && typeof window.ym === 'function' && YM_COUNTER_ID > 0) {
    try {
      window.ym(YM_COUNTER_ID, 'reachGoal', name, props)
    } catch {
      // ignore analytics failures
    }
  }
  if (typeof console !== 'undefined' && typeof console.debug === 'function') {
    console.debug('[market-analytics]', name, props)
  }
}
